export default __webpack_public_path__ + "static/media/postgresql-wordmark.365b891a.svg";